import type { PaymentSubscription } from '@order/graphql';
import { PaymentSubscriptionStatus } from '@order/graphql';

/**
 * If more than one subscription was returned, prefer the active one.
 */
export function getPreferredSubscription(
  subscriptions: ReadonlyArray<Partial<PaymentSubscription>> | undefined,
) {
  return (
    subscriptions?.find(
      ({ status }) => status === PaymentSubscriptionStatus.Active,
    ) ?? subscriptions?.[0]
  );
}
